module.exports = __webpack_public_path__ + "img/Doelgroep - afasie.a6f5a3f3.webp";